// Corporate Navy — banking, consulting, law firms
// Serious navy + gold accents, square-ish corners
module.exports = {
  effect: 'none',
  colors: {
    main:            { light: '#f4f1e8', dark: '#060e1f' },
    card:            { light: '#e8e3d4', dark: '#0e1f3d' },
    surface:         { light: '#d8d2bf', dark: '#162d52' },
    action:          { light: '#1a2b50', dark: '#c9a84c' },
    actionHover:     { light: '#0d1b36', dark: '#d9bc70' },
    textPrimary:     { light: '#0d1b36', dark: '#f0ead8' },
    textSecondary:   { light: '#1a2b50', dark: '#c8bfa4' },
    textMuted:       { light: '#4a5568', dark: '#a09880' },
    textMutedSubtle: { light: '#718096', dark: '#7a7060' },
    border:          { light: '#b0a890', dark: '#2a3f60' },
    borderSubtle:    { light: '#c8c0a8', dark: '#1e3050' },
    link:            { light: '#1a2b50', dark: '#c9a84c' },
    linkBg:          { light: '#e8e3d4', dark: 'rgba(201,168,76,0.12)' },
    linkBorder:      { light: '#b0a890', dark: '#4a3a1a' },
    linkHover:       { light: '#d8d2bf', dark: 'rgba(201,168,76,0.2)' },
    inputBg:         { light: '#faf8f2', dark: '#162d52' },
    inputBorder:     { light: '#b0a890', dark: '#2a3f60' },
    inputText:       { light: '#0d1b36', dark: '#f0ead8' },
    focusRing:       { light: '#1a2b50', dark: '#c9a84c' },
    overlay:         { light: 'rgba(0,0,0,0.55)', dark: 'rgba(0,0,0,0.8)' },
    confirm:         { light: '#b0a890', dark: '#2a3f60' },
    confirmHover:    { light: '#8a8270', dark: '#3a5278' },
    confirmText:     { light: '#0d1b36', dark: '#f0ead8' },
    confirmBg:       { light: '#f4f1e8', dark: '#0e1f3d' },
    confirmBorder:   { light: '#c8c0a8', dark: '#2a3f60' },
    success:         { light: '#166534', dark: '#22c55e' },
    successHover:    { light: '#14532d', dark: '#16a34a' },
    successBg:       { light: '#f0fdf4', dark: 'rgba(5,46,22,0.35)' },
    successText:     { light: '#16a34a', dark: '#4ade80' },
    successBorder:   { light: '#bbf7d0', dark: '#14532d' },
    error:           { light: '#9b1c1c', dark: '#ef4444' },
    errorHover:      { light: '#7f1d1d', dark: '#dc2626' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#1e40af', dark: '#1e40af' },
    infoHover:       { light: '#1d4ed8', dark: '#2563eb' },
    infoBg:          { light: '#eff6ff', dark: 'rgba(30,58,138,0.3)' },
    infoText:        { light: '#3b82f6', dark: '#60a5fa' },
    infoBorder:      { light: '#bfdbfe', dark: '#1e3a8a' },
  },
  borderRadius: {
    card:      '16px',
    container: '10px',
    page:      '12px',
    button:    '6px',
    input:     '6px',
    badge:     '3px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '4px',
    device:  '6px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
